export default __webpack_public_path__ + "static/media/breadstreetkitchen.21fa3260.jpeg";